<template>
  <div>
    <template>
      <ots-main-title></ots-main-title>
      <div class="container mian-con">
        <div class="left-formList">
          <el-form label-width="120px">
          <div v-for="item in formData" :key="item.title" class="mb20">
            <div class="fw500 f18 col_black mb20">{{item.titleName}}</div>
            <!-- 系统组件 -->
            <div class="systemForm">
              <div class="col_grayZ mb20">(系统内置项，不可编辑和删除)</div>
              <div v-for="formItem in item.formList" :key="formItem.displayName">
                <el-form-item :label="formItem.displayName" :required="formItem.required">
                  <form-type :formItem="formItem">
                  </form-type>
                </el-form-item>
              </div>
            </div>
            <!-- 自义定组件 -->
            <draggable  class="userForm" :list="item.extFormList">
              <div v-for="(formItem, index) in item.extFormList" :key="index">
                <!-- {{formItem.displayName}} -->
                <el-form-item :label="formItem.displayName" :required="formItem.required">
                  <form-type :formItem="formItem">
                    <div class="ml20 dealIcon">
                      <i class="el-icon-edit cp mr10" v-show="isCustomSub(formItem.type)" title="编辑" @click="editFormItem(formItem)"></i>
                      <i class="el-icon-delete cp mr10" title="删除" @click="deleteFormItem(item.extFormList, formItem, index)"></i>
                      <i class="el-icon-s-grid cp mr10" title="拖动"></i>
                    </div>
                  </form-type>
                </el-form-item>
              </div>
            </draggable>
          </div>
          </el-form>
        </div>
        
        <div class="right-options">
          <div class="title col_black">组件库</div>
          <div v-for="item in subData" :key="item.type" class="subSection">
            <div class="subTitle col_black">{{item.name}}</div>
            <div class="subList">
              <button 
                class="subItem"
                :class="item.type==='default' ? 'col_grayZ' : ''"
                @click="showSubDialogFn(sub)"
                v-for="sub in item.subList" 
                :key="sub.name" >
                <i class="col_grayZ" :class="sub.icon ? sub.icon + ' iconfont' :'el-icon-circle-plus-outline'"></i>
                <span class="ml5">{{sub.name}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 预置控件 -->
      <ots-custom-dialog :dialog.sync="defaultSetDialog" title="预置控件" v-if="defaultSetDialog">
        <template v-slot:content>
          <el-form>
            <el-form-item label="信息类别" v-model="defaultSub" class="df">
              <span>{{defaultSub.title == 1 ? '基本信息' : '院校信息'}}</span>
            </el-form-item>
            <el-form-item label="是否必填" class="df" prop="required">
              <el-switch v-model="defaultSub.required"></el-switch>
            </el-form-item>
            <el-form-item label="设为查询条件" class="df" prop="queryCondition" v-if="defaultSub.hasOwnProperty('queryCondition')">
              <el-switch v-model="defaultSub.queryCondition"></el-switch>
            </el-form-item>
          </el-form>
        </template>
        <template v-slot:footer>
          <el-button round @click="defaultSetDialog=false">取消</el-button>
          <el-button round type="primary" @click="addSub('system')">确定</el-button>
        </template>
      </ots-custom-dialog>

      <!-- 自定义组件配置表单 -->
      <ots-custom-dialog :dialog.sync="subSetDialog" :title="subTitle" v-if="subSetDialog">
        <template v-slot:content>
          <el-form :model="subForm" :rules="rules" ref="subForm">
            <el-form-item label="信息类别"  prop="title" v-if="hasProperty('title')">
              <el-radio-group v-model="subForm.title">
                <el-radio-button :label='1'>基本信息</el-radio-button>
                <el-radio-button :label='2'>院校信息</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否必填" class="df" prop="required" v-if="hasProperty('required')">
              <el-switch v-model="subForm.required"></el-switch>
            </el-form-item>
            <el-form-item label="标题" prop="displayName" v-if="hasProperty('displayName')">
              <el-input v-model="subForm.displayName" ></el-input>
            </el-form-item>
            <el-form-item label="占位提示" prop="placeholder" v-if="hasProperty('placeholder')">
              <el-input v-model="subForm.placeholder"></el-input>
            </el-form-item>
            <el-form-item label="数据类型" prop="flag" v-if="hasProperty('dataType')">
              <el-radio-group v-model="subForm.dataType">
                <el-radio-button :label='0'>文本</el-radio-button>
                <el-radio-button :label='1'>数字</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item 
              label="最小长度" 
              prop="minSize" 
              v-if="hasProperty('minSize')"
              :rules="[{required: true, validator: checkMinSize, trigger: 'blur'}]"
            >
              <el-input v-model="subForm.minSize"></el-input>
            </el-form-item>
            <el-form-item 
              label="最大长度" 
              prop="maxSize" 
              v-if="hasProperty('maxSize')"
              :rules="[{required: true, validator: checkMaxSize, trigger:'blur'}]"
            >
              <el-input v-model="subForm.maxSize"></el-input>
            </el-form-item>


            <el-form-item label="设为查询条件" class="df" prop="queryCondition" v-if="hasProperty('queryCondition')">
              <el-switch v-model="subForm.queryCondition"></el-switch>
            </el-form-item>


            <el-form-item label="选项设置" v-if="hasProperty('value')">
              <el-form-item
                v-for="(item, index) in subForm.value" 
                :key="index"
                label=""
                :prop="`value.${index}.name`"
                :rules="{required: true, message: '选项值不能为空', trigger: 'blur'}"
              >
                <el-input
                  v-model="item.name" 
                  class="selectValue mt20"
                  prefix-icon="el-icon-s-operation"></el-input>
                  <i class="el-icon-delete ml20 cp col_blue" @click="deleteSelectOption(subForm, index)"></i>
              </el-form-item>
              <!-- <div v-for="(item, index) in subForm.value" :key="index">
                <el-input
                  v-model="item.name" 
                  class="selectValue mt10"
                  prefix-icon="el-icon-s-operation"></el-input>
                  <i class="el-icon-delete ml20 cp col_blue" @click="deleteSelectOption(subForm, index)"></i>
              </div> -->
              <div class="mt20 col_blue cp" @click="addSelectOption(subForm)">
                <i class="el-icon-plus"></i>
                <span class="ml8">添加选项</span>
              </div>
            </el-form-item>
            <el-form-item label="上传说明" prop="remarks" v-if="hasProperty('remarks')">
              <el-input type="textarea" v-model="subForm.remarks"></el-input>
            </el-form-item>
            <el-form-item label="图片大小" prop="filesize" v-if="hasProperty('filesize')"
              :rules="[
                {required: true, validator: checkfileSize, trigger: 'blur'}
              ]"
            >
              <el-input v-model="subForm.filesize">
                <template slot="prepend">不超过</template>
                <template slot="append">kb</template>
              </el-input>
            </el-form-item>
            <el-form-item label="图片类型" prop="fileBack" v-if="hasProperty('fileBack')">
              <el-checkbox-group v-model="subForm.fileBack">
                <el-checkbox label="jpg"></el-checkbox>
                <el-checkbox label="jpeg"></el-checkbox>
                <el-checkbox label="bmp"></el-checkbox>
                <el-checkbox label="png"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-form>
        </template>
        <template v-slot:footer>
          <el-button round @click="subSetDialog=false">取消</el-button>
          <el-button round type="primary" @click="addSub('custom')">确定</el-button>
        </template>
      </ots-custom-dialog>
      <!-- 预览弹窗 -->
      <!-- <ots-custom-dialog 
        :dialog.sync="isShowReview"
        :isFullScreen="true"
        title="报名表预览"
      >
        <template v-slot:content>
          <review-form :formData="formData"/>
        </template>
        
      </ots-custom-dialog> -->
    </template>
    <!-- <template v-else>
      <review-form :formData="formData"/>
    </template> -->
  </div>
</template>

<script>
import { subData, formData, typeForm, titleName } from './configData'
import { checkNumber } from '@/common/verify.js'
import systemApi from '@/http/modules/system'
import draggable from 'vuedraggable'
import FormType from './components/FormType.vue'
import OtsCustomDialog from '../../../package/OtsCustomDialog/OtsCustomDialog.vue'
import { mapMutations } from 'vuex'
import ReviewForm from './reviewForm.vue'
import { selectPlugs } from "@/http/modules/baseSet/majorCourse";

export default {
  name: 'customForm',
  components: { draggable, FormType, OtsCustomDialog, ReviewForm},
  data () {
    return {
      isShowReview: false,
      cancelName: '预览',
      okName: '保存',
      backMethods: 'previewFn',
      saveMethods: 'saveFn',
      subData,
      formData: [],
      defaultSetDialog: false,
      subSetDialog: false,
      subTitle: '单行文本',
      extType: 'User',
      subForm: {
        // title: 1, // 院校类别
        // required: true, // 是否必填
        // displayName: '',
      },
      defaultSub: {
        required: true,
        queryCondition: false
      }, //默认组件
      rules: {
        title: [
          {required: true, message: '必选项'},
        ],
        required: [
          {required: true, },
        ],
        displayName: [
          {required: true, message: '必填项', trigger: 'blur'}
        ]
      },
      configLevelAndSubjectName: {
        levelName: '层次',
        subjectName: '专业'
      }
    }
  },
  computed: {
    // 已有的表单项
    formNameList() {
      let list = []
      this.formData.forEach(item => {
        if (item.formList && item.formList.length) {
          list = list.concat(item.formList.map(el => el.displayName))
        } 
        if (item.extFormList && item.extFormList.length) {
          list = list.concat(item.extFormList.map(el => el.displayName))
        }
      })
      return list
    },
    // 已有的表单项
    formTypeList() {
      let list = []
      this.formData.forEach(item => {
        if (item.formList && item.formList.length) {
          list = list.concat(item.formList.map(el => el.type))
        } 
        if (item.extFormList && item.extFormList.length) {
          list = list.concat(item.extFormList.map(el => el.type))
        }
      })
      return list
    },
    // 保存列表参数
    addExtDefConfigParamModelList() {
      let list = JSON.parse(JSON.stringify(this.formData.reduce((acc, item) => { 
        return item.extFormList && acc.concat(item.extFormList)
      }, [])))

      list.forEach((item, index) => {
        delete item['isEdit']
        item.extType = this.extType
        item.sort = index+1
        if (item.hasOwnProperty('value')) {
          item.value = item.value && item.value.map(item => item.name).join()
        }
        if (item.hasOwnProperty('fileBack')) {
          item.fileBack = item.fileBack && item.fileBack.join()
        }
      })

      return JSON.stringify(list)
    },
  },
  watch: {
    subSetDialog(val) {
      if (!val) {
        this.resetSubForm()
      }
    },
    defaultSetDialog(val) {
      if (!val) {
        this.defaultSub = {
          required: true,
          queryCondition: false
        }
      }
    },
  },
  created() {
    this.initData()
  },
  mounted () {
    this.getConfigData();
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(['SAVE_PAGE_THIS']),
    initData() {
      systemApi.getExtDefConfigListFn({type: 'User'}).then(async ({ data }) => {
        let copyData = JSON.parse(JSON.stringify(formData));
        //下面这个forEach就是为了给管理端的基本信息里，带有hasCheckbox的属性改成true，这样管理端就会显示后面的2个复选框，非管理端就不显示了
        copyData[0].formList.forEach(item => {
          if (item.hasOwnProperty('hasCheckbox')) {
            item.hasCheckbox = true;
          }
        })
        copyData.forEach(item => {
            data.forEach(extItem => {
              if (extItem.title == item.title) {
                extItem.extDefinitionVoList.forEach(formItem => {
                  if (formItem.hasOwnProperty('value') && formItem.value) {
                    formItem['value'] = formItem['value'].split(',').map(item => {
                      return {
                        name : item
                      }
                    })
                  }
                  if (formItem.hasOwnProperty('fileBack') && formItem.fileBack) {
                    formItem['fileBack'] = formItem['fileBack'] ? formItem['fileBack'].split(',') : []
                  }
                })
                item.extFormList = extItem.extDefinitionVoList
              }
            })
        })

        // 此处更新教学点名称 和上传照片的说明
        let { configList } = await this.mixin_getSystemConfig();
        if (configList && configList.length) {
          // 教学点
          let stationConfig = configList.find(item => item.setName == 'stationName')
          if (stationConfig && stationConfig.setValue2) {
            copyData[1].formList.find(item => item.type == 'station').displayName = stationConfig.setValue2
          }
          // 层次
          let levelConfig = configList.find(item => item.setName == 'levelName')
          if (levelConfig && levelConfig.setValue2) {
            const levelItem = copyData[1].extFormList.find(item => item.type == 'level');
            if(levelItem){
              levelItem.displayName = levelConfig.setValue2
            }
          }
          // 专业
          let subjectConfig = configList.find(item => item.setName == 'subjectName')
          if (subjectConfig && subjectConfig.setValue2) {
            const subjectItem = copyData[1].extFormList.find(item => item.type == 'subject');
            if(subjectItem){
              subjectItem.displayName = subjectConfig.setValue2
            }
          }
          // 照片说明
          // setName:stuImgCondition
          // setValue:图片大小限制
          // setValue2:图片后缀
          // setShowText:图片说明
          let stuImgCondition = configList.find(item => item.setName == 'stuImgCondition')
          if (stuImgCondition) {
            let imgFormObj = copyData[0].formList.find(item => item.displayName == '照片')
            if (stuImgCondition.setShowText) {
              imgFormObj.remarks = stuImgCondition.setShowText
            }
            if (stuImgCondition.setValue2) {
              imgFormObj.fileBack = stuImgCondition.setValue2.split(',')
            }
            if (stuImgCondition.setValue) {
              imgFormObj.filesize = stuImgCondition.setValue
            }
          }
        }

        let {code : peCode,data : peData} = await systemApi.getPhoneAndEmailConfigFn();
        if (peCode==1 && peData && peData.length) {
          // 手机说明
          let phoneFormObj = copyData[0].formList.find(item => item.displayName == '手机号')
          if (phoneFormObj) {
            let phoneConfig = peData.find(item => item.fieldName == 'phone')
            if (phoneConfig) {
              phoneFormObj.required = phoneConfig.required == 0 ? false : true;
              phoneFormObj.showInPage = phoneConfig.showInPage == 0 ? false : true;
            }
          }
          // 邮箱说明
          let emailFormObj = copyData[0].formList.find(item => item.displayName == '邮箱')
          if (emailFormObj) {
            let emailConfig = peData.find(item => item.fieldName == 'email')
            if (emailConfig) {
              emailFormObj.required = emailConfig.required == 0 ? false : true;
              emailFormObj.showInPage = emailConfig.showInPage == 0 ? false : true;
            }
          }
        }
        this.formData = copyData;
      });
    },
    getConfigData(){
      this.$api.system.getConfigData().then((res) => {
        if(res.code == 1){
          const configList = res.data.configList;
          if(configList && configList.length){
            configList.forEach(item => {
              if(item.setName == 'levelName'){
                this.configLevelAndSubjectName.levelName = item.setValue2 || '层次'
              }
              if(item.setName == 'subjectName'){
                this.configLevelAndSubjectName.subjectName = item.setValue2 || '专业'
              }
            })
          }
        }
      })
    },
    checkfileSize(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入'))
      }
      return checkNumber(rule, value, callback, 5120)
    },
    checkMinSize(rule, value, callback, max) {
      if (!value) {
        return callback(new Error('请输入'))
      }
      if (isNaN(Number(value))) {
        return callback(new Error('请输入整数值'))
      }
      if (!max || max && isNaN(Number(max))) {
        max = Number.MAX_VALUE
      }
      if (value%1 !== 0) {
        return callback(new Error('请输入整数值'))
      }
      if (value > max) {
        callback(new Error(`超过最大值${max}，请输入有效数值`))
      } else {
        callback()
      }
      // return checkNumber(rule, value, callback)
    },


    /**
     * @param { 最大长度表单校验 }
     */
    checkMaxSize(rule, value, callback, max) {
      value = Number(value)

      if ( (value % 1 !== 0) || isNaN(Number(value)) ) return callback(new Error('请输入整数值！'))
      if ( !value ) return callback(new Error('请输入最大长度！'))
      if ( !max || max && isNaN(Number(max)) ) max = Number.MAX_VALUE
      if ( Number(value) < Number(this.subForm.minSize) )  return callback(new Error('最大值不能小于最小值！'))
      if ( value > max ) return callback(new Error(`超过最大值${max}，请输入有效数值！`))
      
      callback()
    },
    checkMove(val) {
    },
    addSelectOption(item) {
      item.value.push({name: ''})
    },
    deleteSelectOption(item, index) {
      if (item.value && item.value.length > 2) {
        item.value.splice(index, 1)
      } else {
        this.$message.warning('选项不能少于两个')
      }
    },
    editFormItem(item) {
      
      // 需要过滤一下数据，不然弹窗会显示脏数据
      let subFormList = typeForm[item.type]
      this.subTitle = titleName[item.type]
      let delList = Object.keys(item).filter(a => subFormList.map(b => b.name).indexOf(a) < 0)
      delList.splice(delList.findIndex(a => a == 'type'), 1)
      delList.splice(delList.findIndex(a => a == 'id'), 1)
      
      delList.forEach(a => {
        delete item[a]
      })

      item.isEdit = true
      this.subForm = item
      this.subSetDialog = true
    },
    async deleteFormItem(list, item, index) {
      if (!item.id){ // 页面添加还没存
        list.splice(index, 1)
      } else {
        const {name} = item
        const { data: isHasData } = await systemApi.selectExtDefConfigFn({name})
        if (isHasData) {
          this.$confirm( '已有学生填报信息，是否确认删除该字段？', '提示', {
            type: 'warning'
          }).then(() => {
            systemApi.deleteExtDefConfigFn({ids: item.id}).then(({ code }) => {
              if (code == 1) {
                list.splice(index, 1)
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }
            })
          }).catch(() => {})
        } else {
          systemApi.deleteExtDefConfigFn({ids: item.id}).then(({ code }) => {
            if (code == 1) {
              list.splice(index, 1)
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
          })
        }
      }
    },
    showSubDialogFn(subItem) {
      if (this.isCustomSub(subItem.type)) {
        this.subSetDialog = true
        this.subTitle = subItem.name
        let subFormList = typeForm[subItem.type]
        subFormList && subFormList.forEach(item => {
          // this.subForm[item.name] = item.hasOwnProperty('defaultValue') ? item.defaultValue : ''
          this.$set(this.subForm, item.name, item.hasOwnProperty('defaultValue') ? item.defaultValue : '')
          this.$set(this.subForm, 'type', subItem.type)
          // 设置表单必填项
          if (!this.rules.hasOwnProperty(item.name) && item.required) {
            this.$set(this.rules, item.name, { required: true, message: 'required'})
          }
        })
        if (this.subForm.hasOwnProperty('value')) {
          this.subForm['value'] = this.subForm['value'].split(',').map(item => {
            return {
              name : item
            }
          })
        }
        if (this.subForm.hasOwnProperty('fileBack')) {
          this.subForm['fileBack'] = this.subForm['fileBack'] ? this.subForm['fileBack'].split(',') : []
        }
      } else { // 添加预置控件===数据已配好
        if (this.isCanAdd(subItem.type)) {
            let { icon, name, ...newdefaultSub } = subItem
            newdefaultSub.displayName = name
            this.defaultSub = Object.assign(this.defaultSub, newdefaultSub)
            // 把出生日期的查询条件去掉了
            if (this.defaultSub.type == 'birthday') {
              delete this.defaultSub.queryCondition
            }
            this.defaultSetDialog = true

            // this.formData.forEach(item => {
            //   if (item.title == subItem.title) {
                
            //     item.extFormList.push(newdefaultSub)
            //   }
            // })
        }
      }
    },
    hasProperty(prop) {
      return this.subForm.hasOwnProperty(prop)
    },
    /**
     * 判断组件是自定义还是预置组件
     */
    isCustomSub(type) {
      // 预置组件不能编辑
      const defaultType = subData.filter(item => item.type == 'default')[0].subList.map(item => item.type)
      return defaultType.indexOf(type) < 0
    },
    isCanAdd(name) {
      if (this.formTypeList.indexOf(name) > -1) {
        this.$message.error('已存在同类型组件，无法添加。')
      }
      return this.formTypeList.indexOf(name) < 0
    },
    addSub(type) {
      let isCustom = type == 'custom'
      let subItem = isCustom ? this.subForm : this.defaultSub
      if (!(subItem.isEdit || this.isCanAdd(subItem.type))) {
          return
      }
      if (isCustom) {
        this.$refs['subForm'].validate(valid => {
          if (valid) {
            let extAll = this.formData.reduce((acc, item) => {
              return acc.concat(item.extFormList)
            }, [])
            // 处理编辑项
            if (extAll.filter(extItem => extItem.displayName == subItem.displayName).length > 1) {
              this.$message.error('已存在同名组件，请更改标题名称。')
              return
            }
            let editItem = extAll.find(extItem => extItem.displayName == subItem.displayName)
            if (editItem) {
              editItem = subItem
            } else {
              extAll.push(subItem)
            }
            this.formData.forEach(item => {
              item.extFormList = extAll.filter(extItem => extItem.title == item.title)
            })
            this.subSetDialog = false
          }
        })
      } else {
        if(subItem.type == 'level'){
          subItem.displayName = this.configLevelAndSubjectName.levelName;
        }
        if(subItem.type == 'subject'){
          subItem.displayName = this.configLevelAndSubjectName.subjectName;
        }
        this.formData.forEach(item => {
          if (item.title == subItem.title) {
            item.extFormList.push(subItem)
          }
        })
        this.defaultSetDialog = false
      }
    },
    resetSubForm() {
      this.subForm = {
        // extType: 'User',
        // title: 1, // 院校类别
        // required: false, // 是否必填
        // displayName: '',
      }
      this.rules = {
        title: [
          {required: true, message: '必选项'},
        ],
        required: [
          {required: true, },
        ],
        displayName: [
          {required: true, message: '必填项', trigger: 'blur'}
        ]
      }
    },
    previewFn() {
      this.saveFn().then(() => {
        this.$router.push({
          name: 'reviewForm',
        })
      }).catch(() => {
        this.$message.error('保存失败，请保存成功后预览')
      })
    },
    saveFn() {
      return new Promise(async resolve => {
        let copyData = JSON.parse(JSON.stringify(this.formData[0]));
        let requiredCount = copyData.formList.filter(item => item.displayName == '手机号' || item.displayName == '邮箱').filter(item => item.required == false).length;
        const { code,data} = await systemApi.getConfigData();
        if(code == 1){
          const smsCheckForSignObj = data.configList.find(item => item.setName=="smsCheckForSign");
          if(smsCheckForSignObj){
            if(smsCheckForSignObj.setValue == '1' && requiredCount == 2){
              this.$alert("系统设置中开启了报名开启短信/邮件验证，手机号、邮箱必须选其一设置为必填项", "提示", {
                confirmButtonText: "确定",
                roundButton: true,
              });
              return;
            }
          }
          const allowRegisterObj = data.configList.find(item => item.setName=="allowRegister");
          if(allowRegisterObj){
            if(allowRegisterObj.setValue == '1' && requiredCount == 2){
              this.$alert("系统开启了允许学生平台自主注册，手机号和邮箱必须选其一设置为必填", "提示", {
                confirmButtonText: "确定",
                roundButton: true,
              });
              return;
            }
          }
        }
        const { code : configCode,data : configData } = await systemApi.getConfigMessageInfo()
        if(configCode == 1){
          let registCheck = false;
          let loginCheck = false;
          configData.forEach(e=>{
            // 根据学生注册时填写的手机号或邮箱，进行短信或邮件校验,0-关闭；1-开启
            if(e.setName == "registCheck"){
              registCheck = e.setValue === 1 ? true : false;
            }
            if(e.setName == "loginCheck"){
              loginCheck = e.setValue === 1 ? true : false;
            }
          })
          if((registCheck || loginCheck) && requiredCount == 2){
            this.$alert("短信设置中打开了注册验证/登录验证，手机或邮箱至少有一个必填", "提示", {
              confirmButtonText: "确定",
              roundButton: true,
            });
            return;
          }
        }
        systemApi.saveExtDefConfigListFn({addExtDefConfigParamModelList: this.addExtDefConfigParamModelList}).then(({ code, data }) => {
          if (code == 1) {
            //--保存手机号，邮箱的2个复选框的值 -- begin--------------------------
            let copyData = JSON.parse(JSON.stringify(this.formData[0]));
            let phoneConfig = copyData.formList.find(item => item.displayName == '手机号');
            let emailConfig = copyData.formList.find(item => item.displayName == '邮箱');
            let params = {
              phoneConfig: (phoneConfig.required ?  1 : 0) + ',' + (phoneConfig.showInPage ?  1 : 0),
              emailConfig: (emailConfig.required ?  1 : 0) + ',' + (emailConfig.showInPage ?  1 : 0),
            }
            systemApi.savePhoneAndEmailConfigFn(params);
            //--保存手机号，邮箱的2个复选框的值 -- end--------------------------
            this.$message.success('保存成功')

            selectPlugs({ levelType: "level", subjectType: "subject" }).then(res=>{
              if(res.code == 1 && res.data == "true"){
                this.$confirm("检测到您自定义设置了层次及专业字段，请到基础设置进行专业课程设置！", "配置结果", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                  this.$router.push({ name: 'majorCourse' })
                }).catch(()=>{
                  return false;
                });
              }
            })

            this.initData()
            resolve()
          }
        })
      })
    },
  }
}
</script>

<style lang="less">
  .container {
    position: relative;
    display: flex;
    justify-content: space-between;
    &>div {
      background: #fff;
      border-radius: 8px;
    }
    .right-options {
      width: 320px;
      height: 546px;
      max-height: calc(100vh - 300px);
      overflow: auto;
      position: fixed;
      right: 24px;
      .title {
        text-align: center;
        font-size: 18px;
        font-weight: 500;
        line-height: 57px;
        border-bottom: 1px solid #F1F2F5;
      }
      .subSection {
        padding: 0 24px;
        .subTitle {
          font-size: 16px;
          font-weight: 500;
          line-height: 48px;
        }
        .subList {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .subItem{
            width: 130px;
            height: 40px;
            margin-bottom: 12px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px solid #F1F2F5;
            text-align: left;
            padding-left: 25px;
            cursor: pointer;
            &:hover{
              color: #006AFF;
              border: 1px solid #006AFF;
              i{
                color: inherit;
              }
            }
          }
        }
      }
    }
    .left-formList {
      box-sizing: border-box;
      width: calc(100% - 340px);
      padding: 20px;
      .systemForm {
        background: #F8F9FC;
        border-radius: 4px;
        padding: 20px 30px;
      }
      .userForm {
        padding: 20px 30px;
      }
      // 菜单项格式
      .el-form-item {
        border: 1px solid transparent;
        // width: fit-content;
      }
      .dealIcon {
        display: flex;
        align-items: center;
      }
      .el-form-item:hover {
        // background: rgba(11, 102, 230, 0.08);
        // border: 1px solid #0B66E6;
        .dealIcon i:hover {
          color: #0B66E6;
        }
      }
    }
  }
  .selectValue  .el-input__inner{
    padding-left: 30px!important;
  }
  @media screen and (max-width: 1280px){
    .container .right-options {
      position: relative;
      right: 0;
    }
  }
</style>